import React from "react";
import { Field, FieldRenderProps } from "react-final-form";

import { withFormContext, FormContextType } from "../formContext";

import { compose, emptyArrayValidator, emptyValidator } from "utils/validators";

type Props = {
  name: string;
  render: (props: FieldRenderProps<any>) => React.ReactNode;
  validate: (value: any) => boolean;
};

class FieldControl extends React.Component<Props & FormContextType> {
  componentDidMount(): void {
    const { name, registerField } = this.props;
    registerField && registerField({ name });
  }

  render() {
    const { name, validate, render } = this.props;
    return <Field name={name} render={render} validate={validate} />;
  }
}

const FieldControlWithContext = withFormContext(FieldControl);

const withFieldControl = (Wrapped: React.ClassType<any, any, any>) => {
  class Wrapper extends React.Component<any> {
    renderInput = (props: FieldRenderProps<any>) => {
      const { validate, ...rest } = this.props;

      return <Wrapped {...rest} {...props} />;
    };

    render() {
      const { name, validate, required, multi, ...props } = this.props;

      const defaultValidator = multi
        ? emptyArrayValidator(emptyValidator)
        : emptyValidator;

      return (
        <FieldControlWithContext
          name={name}
          render={this.renderInput}
          validate={
            required
              ? validate
                ? compose(defaultValidator, validate)
                : defaultValidator
              : validate
          }
          {...props}
        />
      );
    }
  }

  return Wrapper;
};

export default withFieldControl;
